import React from "react";
import { useSelector } from "react-redux";
import { trackSelectItem } from "../../../../../../monitoring/interaction/prescription-detail";
import type { TableRowProps } from "../../types";
import { AppState } from "../../../../../../store";
import ItemDetails from "../ItemDetails";
import { DispensedQuantity, PrescribedQuantity } from "../QuantityIndicators";
import QuantitySelector from "../QuantitySelector";
import * as Styles from "./TableRowStyles";
import { useTrackingProperties } from "../../../../../../monitoring/utils";

const TableRow: React.FC<TableRowProps> = ({ item, canDispense, onClick }) => {
  const prescriptionId = useSelector((state: AppState) => state.prescription.prescription.id);
  const { drugstoreId, chainId, drugstoreName, chainName, drugstoreUF } = useTrackingProperties();

  function handleClick(): void {
    trackSelectItem({
      prescriptionId,
      itemId: item.id,
      canDispensePartial: item.isPartialDispensationEnabled ?? false,
      drugstoreId,
      chainId,
      drugstoreName,
      chainName,
      drugstoreUF,
    });
    if (canDispense) {
      onClick(item);
    }
  }

  return (
    <Styles.Row
      onClick={canDispense ? handleClick : undefined}
    >
      <Styles.TableCell>
        <ItemDetails item={item} canDispense={canDispense} />
      </Styles.TableCell>
      <Styles.TableCell>
        <PrescribedQuantity
          prescribedAmount={item.prescribedQuantity ?? 0}
          unit={item.unit ?? ""}
        />
      </Styles.TableCell>
      <Styles.TableCell>
        <DispensedQuantity
          dispensedAmount={item.dispensedQuantity ?? 0}
          prescribedAmount={item.prescribedQuantity ?? 0}
          availableQuantity={item.availableQuantity ?? 0}
          unit={item.unit ?? ""}
        />
      </Styles.TableCell>
      <Styles.TableCell onClick={(e) => e.stopPropagation()}>
        <QuantitySelector item={item} />
      </Styles.TableCell>
    </Styles.Row>
  );
};

export default TableRow;